export default "__VITE_ASSET__D1E2zaBY__"